import React, { FC } from 'react';
import { IHandledDocument, ISearchProfile } from '../../../types';
import ResultItem from '../../ResultItem';
import { DocumentNamePosition } from '../../ResultItem/types';
import styles from './index.module.scss';
import { Empty } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/pro-solid-svg-icons';

export interface ISearchProfileGroupProps {
  searchProfile: ISearchProfile;
  documents: IHandledDocument[];
}

const SearchProfileGroup: FC<ISearchProfileGroupProps> = props => {
  const { searchProfile, documents } = props;
  const { colorValue, name } = searchProfile;

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {!!colorValue && (
          <FontAwesomeIcon
            icon={faTag}
            style={{ color: colorValue }}
            className={styles.colorIndicator}
          ></FontAwesomeIcon>
        )}
        {name}
      </div>
      {documents.length > 0 ? (
        documents.map(document => (
          <ResultItem
            document={document}
            key={document.filePath}
            namePosition={DocumentNamePosition.PartNode}
            mainSearchProfile={searchProfile}
          />
        ))
      ) : (
        <Empty />
      )}
    </div>
  );
};
export default SearchProfileGroup;
